export enum ClosedPeriodFrequency {
  Once = 'ONCE',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
}
